module.exports = __webpack_public_path__ + "img/logo-2.1fc3f367.svg";